/* unplugin-vue-components disabled */import { render } from "./MainFoot.vue?vue&type=template&id=8bbcf5e2&scoped=true"
import script from "./MainFoot.vue?vue&type=script&lang=js"
export * from "./MainFoot.vue?vue&type=script&lang=js"

import "./MainFoot.vue?vue&type=style&index=0&id=8bbcf5e2&scoped=true&lang=css"

import exportComponent from "D:\\WorkPlace\\官网\\html-bcepd-project-website-digital-read\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bbcf5e2"]])

export default __exports__